
import { Cpu, ShieldCheck, Atom, Zap, Layers, HeartPulse } from 'lucide-react';
import { Link } from 'react-router-dom';

const FocusSectorsSectionSv = () => {
  return (
  <section className="py-24 bg-gradient-to-br from-[hsl(var(--focus-areas-start))] via-[hsl(var(--focus-areas-mid))] to-[hsl(var(--focus-areas-end))]">
    <div className="w-full px-8 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900">Fokusområden</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-on-scroll">
          <Link to="/sv/focus-areas/ai-autonomous" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Cpu className="w-10 h-10 mb-4 text-blue-700" />
              <h3 className="text-2xl font-bold mb-2 text-blue-700">AI & Autonoma system</h3>
              <p className="text-gray-600">för samhällsomvandling</p>
            </div>
          </Link>
          <Link to="/sv/focus-areas/digital-technology" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <ShieldCheck className="w-10 h-10 mb-4 text-green-700" />
              <h3 className="text-2xl font-bold mb-2 text-green-700">Digital teknologi</h3>
              <p className="text-gray-600">för produktivitet och säkerhet</p>
            </div>
          </Link>
          <Link to="/sv/focus-areas/quantum" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Atom className="w-10 h-10 mb-4 text-purple-700" />
              <h3 className="text-2xl font-bold mb-2 text-purple-700">Kvant</h3>
              <p className="text-gray-600">för säkerhet och industri</p>
            </div>
          </Link>
          <Link to="/sv/focus-areas/energy" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Zap className="w-10 h-10 mb-4 text-yellow-700" />
              <h3 className="text-2xl font-bold mb-2 text-yellow-700">Energi</h3>
              <p className="text-gray-600">för fossilfri elektrifiering</p>
            </div>
          </Link>
          <Link to="/sv/focus-areas/materials" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <Layers className="w-10 h-10 mb-4 text-pink-700" />
              <h3 className="text-2xl font-bold mb-2 text-pink-700">Material</h3>
              <p className="text-gray-600">för transformation</p>
            </div>
          </Link>
          <Link to="/sv/focus-areas/biotechnology" className="group">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center flex flex-col items-center group-hover:shadow-2xl transition-all duration-300 group-hover:scale-105">
              <HeartPulse className="w-10 h-10 mb-4 text-teal-700" />
              <h3 className="text-2xl font-bold mb-2 text-teal-700">Bioteknik</h3>
              <p className="text-gray-600">för hälsa och klimat</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  </section>
  );
};

export default FocusSectorsSectionSv;
